import React, { useEffect, useState } from "react";
import "../../assets/styles/loader.css";
import LocalLoader from "../../Components/Loader/LocalLoader.js";


import { TableWrapper } from "../../Components/styledConstant.js";
import { getAnalyseList, getTidReportList } from "../../utils/api.js";
import { isEmpty } from "../../utils/common.js";
import { FilterWrapper } from "../../assets/styles/FilterStyle.js";
import { AlertWrapper } from "../../assets/styles/AlerWrapper.js";
import DatePicker from "react-datepicker";
import { CSVLink } from "react-csv";
import moment from "moment";
require("react-datepicker/dist/react-datepicker.css");

const formatAmount = (val) => {
    if (val === null || val === undefined) return "-";

    return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(val);
};


const TidReport = () => {
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState(null);
    const [msg, setMsg] = useState({});

    const [list, setList] = useState([]);




    const formatAmount = (val) => {
        if (val === null || val === undefined) return "-";

        return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(val);
    };

    const getList = async () => {


        const formatted = moment(date).format("YYYY-MM-DD")
        setLoading(true);

        getTidReportList(formatted).then((resp) => {
            setLoading(false);

            if (resp?.data?.success) {
                setList(resp?.data?.data);

            }
        });
    };



    return (
        <div style={{ padding: "30px" }}>
            <div>   {!isEmpty(msg) && (
                <AlertWrapper className={`${msg.type} globle`}>
                    <span className="close" onClick={() => setMsg({})}>
                        ×
                    </span>
                    {msg.msg}
                </AlertWrapper>
            )}

                <FilterWrapper className={`display_data`} style={{marginTop:"40px"}}>
                    <div className="filterBox">
                        <div className="flex" style={{ width: "100%", justifyContent: "space-between" }}>
                            <h2 style={{ color: "#fff" }}>Terminal Report</h2>
                            <div style={{ display: "flex", gap: "20px" }}>
                                <div className="input-field">
                                    <div className="flex">
                                        <DatePicker
                                            showIcon
                                            className="date-picker2 date_type"
                                            placeholderText="Select Date"
                                            selected={date}

                                            yearDropdownItemNumber={100}
                                            scrollableYearDropdown={true}
                                            showYearDropdown
                                            onKeyDown={(e) => e.preventDefault()}
                                            onChange={(date) => setDate(date)}
                                            maxDate={new Date()}
                                        />
                                    </div>
                                </div>
                                <button
                                    className="userlist_btn"
                                    onClick={getList}
                                    disabled={!date}
                                >
                                    search
                                </button>
                                {
                                    !isEmpty(list)
                                    && <CSVLink

                                        data={list}
                                        filename={`Terminal_Repprt_${moment(date).format("YYYY-MM-DD")}.csv`}
                                    >
                                        <button
                                            className="userlist_btn"

                                        >
                                          <i class="fa-solid fa-download"></i> CSV
                                        </button>

                                    </CSVLink>
                                }


                            </div>
                        </div>
                    </div>
                </FilterWrapper>



            </div>



            {(

                <div className="table-loader">
                    {loading && <LocalLoader className="tableLoader" />}
                    <TableWrapper className="table-card-wrapper">
                        <table className="table custom-table">
                            <thead>
                                <tr>
                                    <th style={{ width: "60px" }}>S.No</th>
                                    <th>Terminal ID</th>
                                    <th>Terminal Date</th>
                                    <th>Terminal Amount</th>

                                    {/* <th style={{ width: "120px" }}>Actions</th> */}
                                </tr>
                            </thead>

                            <tbody>
                                {list?.map((item, i) => (
                                    <tr key={item.tid}>
                                        <td>{i + 1}</td>

                                        <td className="text-ellipsis">{item?.tid}</td>
                                        <td className="text-ellipsis">{item?.date}</td>
                                        <td className="text-ellipsis">{formatAmount(item?.amount)}</td>


                                    </tr>
                                ))}

                                {!loading && list.length < 1 && (
                                    <tr>
                                        <td colSpan={7} style={{ textAlign: "center", color: "red" }}>
                                            {
                                                !date ? "No data available. Please choose a date."
                                                    : "No data found. Please select a different date."
                                            }
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </TableWrapper>
                </div>
            )}

        </div>
    );
};

export default TidReport;

